// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleArrow_root__EmWAl","open":"ToggleArrow_open__GTK8N"};